import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
  SUBMITTAL_STATUS,
  SUBMITTAL_STATUS_LABEL,
  SUBMITTAL_STATUS_PILL_MODIFIER,
} from '@/pages/Submittals/constants'
import {
  CheckHistoryOutlined,
  CheckDoubleOutlined,
  XCircleSolid,
  ClockSolid,
} from '@/assets/svgs/status'

const VISIBLE_STATUSES = new Set([
  SUBMITTAL_STATUS.DRAFT,
  SUBMITTAL_STATUS.PENDING_REVIEW,
  SUBMITTAL_STATUS.APPROVED,
  SUBMITTAL_STATUS.REJECTED,
  SUBMITTAL_STATUS.REPLACED,
  SUBMITTAL_STATUS.DELETED,
  SUBMITTAL_STATUS.PASSED_DEADLINE,
])

const STATUS_ICON = {
  [SUBMITTAL_STATUS.DRAFT]: CheckHistoryOutlined,
  [SUBMITTAL_STATUS.PENDING_REVIEW]: CheckHistoryOutlined,
  [SUBMITTAL_STATUS.APPROVED]: CheckDoubleOutlined,
  [SUBMITTAL_STATUS.REJECTED]: XCircleSolid,
  [SUBMITTAL_STATUS.REPLACED]: XCircleSolid,
  [SUBMITTAL_STATUS.DELETED]: ClockSolid,
  [SUBMITTAL_STATUS.PASSED_DEADLINE]: ClockSolid,
}

const PILL_COLORS = {
  approved: 'pill-approved',
  rejected: 'pill-rejected',
  'passed-deadline': 'pill-rejected',
  'pending-review': 'pill-pending-review',
  draft: 'pill-neutral',
  deleted: 'pill-neutral',
  replaced: 'pill-neutral',
}

const SubmittalStatusPill = ({ status }) => {
  if (!status || !VISIBLE_STATUSES.has(status)) return null
  const modifier = SUBMITTAL_STATUS_PILL_MODIFIER[status]
  if (!modifier) return null
  const Icon = STATUS_ICON[status]
  return (
    <span
      className={clsx(
        'inline-flex items-center h-6 px-2 whitespace-nowrap rounded-2xl type-meta-heavy',
        PILL_COLORS[modifier]
      )}
    >
      {Icon && <Icon className="mr-1 w-4 h-4 shrink-0" />}
      {SUBMITTAL_STATUS_LABEL[status] ?? status}
    </span>
  )
}

SubmittalStatusPill.propTypes = {
  status: PropTypes.string,
}

export default SubmittalStatusPill
